import { SovosEnvironment } from '../types';
const rootUrls = {
    [SovosEnvironment.dev]: 'https://api-platform-dev.sovos.com/',
    [SovosEnvironment.prod]: 'https://api.sovos.com/v1/internal/platform-services',
    [SovosEnvironment.uat]: 'https://api-test.sovos.com/v1/internal/platform-services',
};
export default rootUrls;
